import { DATE_FORMAT } from '@constants'
import type { DateValue } from '@integrations/core'
import moment from '@integrations/date-time'
import { formatTime } from 'mmfintech-commons'

export function formatDisplayDate(date: unknown): string {
  if (!date) return ''

  const value = moment(date as DateValue)
  return value.isValid() ? value.format(DATE_FORMAT.DATE) : ''
}

export function formatDisplayDateTime(date: unknown, separator = ', '): string {
  const displayDate = formatDisplayDate(date)
  return displayDate ? `${displayDate}${separator}${formatTime(date)}` : ''
}
